import React from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';

export default function ReferencesCard({ reference, index }) {
  const { reference_data } = reference;
  
  if (!reference_data) return null;

  const { name, phone, relationship } = reference_data;

  // Formatear teléfono para mejor visualización
  const formatPhone = (phoneNumber) => {
    if (!phoneNumber) return 'N/A';
    // Remover +52 si existe y formatear
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 12 && cleaned.startsWith('52')) {
      const number = cleaned.slice(2);
      return `+52 ${number.slice(0, 2)} ${number.slice(2, 6)} ${number.slice(6)}`;
    }
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 6)} ${cleaned.slice(6)}`;
    }
    return phoneNumber;
  };

  const cardHeader = (
    <div style={{
      background: 'linear-gradient(135deg, #23b56e 0%, #0ea5e9 100%)',
      padding: '1.5rem',
      borderRadius: '12px 12px 0 0',
      color: 'white'
    }}>
      <div className="flex align-items-center justify-content-between">
        <div className="flex align-items-center gap-2">
          <i className="pi pi-user" style={{ fontSize: '1.5rem' }}></i>
          <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>
            Referencia {index + 1}
          </span>
        </div>
        <Tag 
          value="Contacto" 
          severity="info" 
          style={{ 
            background: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)'
          }}
        />
      </div>
    </div>
  );

  return (
    <Card 
      header={cardHeader}
      className="shadow-3 hover:shadow-4 transition-all transition-duration-300"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #e9ecef',
        height: '100%'
      }}
    >
      <div className="flex flex-column gap-3">
        {/* Nombre */}
        <div className="flex align-items-start gap-3">
          <div 
            className="flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #23b56e 0%, #0ea5e9 100%)',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              flexShrink: 0
            }}
          >
            {name ? name.charAt(0).toUpperCase() : '?'}
          </div>
          <div className="flex-1">
            <div className="text-500 text-sm mb-1">Nombre completo</div>
            <div className="text-900 font-semibold text-lg">
              {name || 'No especificado'}
            </div>
          </div>
        </div>

        {/* Relación */}
        <div className="flex align-items-center gap-3 p-3" 
          style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}
        >
          <i className="pi pi-users text-primary" style={{ fontSize: '1.2rem' }}></i>
          <div className="flex-1">
            <div className="text-500 text-sm mb-1">Relación</div>
            <div className="text-900 font-medium">
              {relationship || 'No especificada'}
            </div>
          </div>
        </div>

        {/* Teléfono */}
        <div className="flex align-items-center gap-3 p-3" 
          style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}
        >
          <i className="pi pi-phone text-primary" style={{ fontSize: '1.2rem' }}></i>
          <div className="flex-1">
            <div className="text-500 text-sm mb-1">Teléfono</div>
            <div className="text-900 font-medium">
              {formatPhone(phone)}
            </div>
          </div>
          {phone && (
            <a 
              href={`tel:${phone}`}
              className="p-button p-button-rounded p-button-text p-button-sm"
              style={{ color: '#667eea' }}
              title="Llamar"
            >
              <i className="pi pi-phone"></i>
            </a>
          )}
        </div>
      </div>
    </Card>
  );
}

